import Translations from "./Translations";
export default Translations;
